import { z } from 'zod';
export const AT_LEAST_ONE_PROPERTY_MESSAGE = 'At least one property must be provided';
export function createPartialStrictObjectSchemaWithAtLeastOneProperty(schema) {
    const rawShape = schema.shape;
    const partialShape = {};
    for (const key of Object.keys(rawShape)){
        partialShape[key] = rawShape[key].exactOptional();
    }
    return z.object(partialShape).strict().refine((obj)=>Object.keys(obj).length > 0, {
        message: AT_LEAST_ONE_PROPERTY_MESSAGE
    });
}
